import { createSelector, Selector, State, StateContext } from '@ngxs/store';
import { Receiver } from '@ngxs-labs/emitter';
import { IdNamePair } from '../../@models/index';
import { ChangeDetectorRef, inject, Injectable, Injector } from '@angular/core';
import { ContactService } from '../../@services/contacts.service';
import { DropdownService } from '../../@services';
import { ENDPOINTS } from 'src/app/@config/endpoints';

@State<IdNamePair[]>({
  name: 'opportunityStatus',
  defaults: []
})
@Injectable()
export class OpportunityStatusState {

  private static service: DropdownService
 

  static hasAny() {
    return createSelector([OpportunityStatusState], (state: IdNamePair[]) => {
      return state.length > 0;
    });
  }

  static getNameById(id: number) {
    return createSelector([OpportunityStatusState], (state: IdNamePair[]) => {
      return state.find((item: IdNamePair) => item.id === id).name;
    });
  }

  constructor(injector: Injector) {
    OpportunityStatusState.service = injector.get(DropdownService);
  }

  @Receiver()
  static loadAll({ setState }: StateContext<OpportunityStatusState>, data: any ) {
    this.service.getDropdownData(ENDPOINTS.getOpportunityProductStatusListAsync(data.payload.tenantId, data.payload.phaseId)).subscribe(
      (data: IdNamePair[]) => {
        setState(data);
      }
    );
  }

}
